import React, { useState } from 'react'
import ScrollButton from './ScrollButton'

import CarouselApp from './CarouselApp'
import Modal from './Modal';

import screenshot from '../assets/IMG_4299.PNG'
import screenshot2 from '../assets/IMG_4302.PNG'
import screenshot3 from '../assets/IMG_4441.PNG'
import screenshot4 from '../assets/IMG_4460.PNG'

export default function AppDetail() {

    const screenshots = [screenshot, screenshot2, screenshot3, screenshot4];

    const [modalOpen, setModalOpen] = useState(false);

    return (
        <div id="app-detail" className="flex flex-col"> 
            <h1 className="text-4xl font-semibold">O aplikaci</h1>
            <p className='my-5'>Aplikace Jídelák vznikla jako bakalářská práce, ale může být vaším <strong>plnohodnotným pomocníkem</strong>.</p>

            <div className='flex flex-col md:flex-row py-2'>
                <div className='flex flex-col md:w-[50%] gap-3 justify-center'>
                    <p className='font-bold'>Mezi její hlavní přínosy lze zařadit:</p>
                    <ul className='pl-5 my-2'>
                        <li>📝 pomoc s plánováním jídel</li>
                        <li>🥗 inspirace v receptech</li>
                        <li>📈 sledování stravování</li>
                        <li>🛒 tvorba nákupních seznamů</li>
                    </ul>
                    <p className='mb-2'>A umí toho mnohem víc, co takhle <strong>ji vyzkoušet</strong>?</p>
                    <ScrollButton destination="download" text="Stáhnout aplikaci" color="bg-orange-400" />
                </div>
                <div className='flex mt-5 md:mt-0 sm:max-w-[50%] mx-auto h-96'>
                    <CarouselApp 
                        setModalOpen={setModalOpen} 
                        screenshots={screenshots}
                    />
                </div>
            </div>

            {modalOpen && 
            <Modal 
                screenshots={screenshots}
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
            />}

        </div>
    )
}
